import type { ReactElement } from 'react';

export type IconName =
  | 'analytics'
  | 'licences'
  | 'company'
  | 'logout'
  | 'clock'
  | 'warning'
  | 'search';

const PATHS: Record<IconName, ReactElement> = {
  analytics: <path d="M4 20V4M4 20h16M8 16v-4M12 16V8M16 16v-6" />,
  licences: (
    <>
      <circle cx="9" cy="8" r="3" />
      <path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6M17 11a3 3 0 0 0 0-6M21 20c0-2.4-1.4-4.4-3.5-5.4" />
    </>
  ),
  company: (
    <>
      <path d="M5 20V5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v15M15 10h3a1 1 0 0 1 1 1v9M3 20h18" />
      <path d="M9 8h2M9 12h2M9 16h2" />
    </>
  ),
  logout: (
    <path d="M14 8V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-3M9 12h12l-3-3m3 3l-3 3" />
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </>
  ),
  warning: (
    <>
      <path d="M12 4l9 16H3z" />
      <path d="M12 10v4M12 17h.01" />
    </>
  ),
  search: (
    <>
      <circle cx="11" cy="11" r="7" />
      <path d="M20 20l-3.5-3.5" />
    </>
  ),
};

/** Thin-stroke line icons from the design, drawn in `currentColor`. */
export function Icon({ name, size = 24 }: { name: IconName; size?: number }): ReactElement {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      className="flex-none"
    >
      {PATHS[name]}
    </svg>
  );
}
